<script setup lang="ts">
import { useAuthStore } from '~/stores/auth.store';
import type { IExternalToast } from '~/interfaces/content/marketing-toasts';

interface IProps {
  toast: IExternalToast | undefined;
}

const props = withDefaults(defineProps<IProps>(), {});

const { $toastService } = useNuxtApp();
const { $contentService } = useServices();
const authStore = useAuthStore();

const kentico = ref(null);
const kenticoContent = ref<any | null>(null);
const visible = ref<boolean>(false);

const closeToast = () => {
  const el: HTMLElement = document.getElementById('close-toast');
  if (!!el) {
    el.onclick = () => {
      // $toastService.toastService.setToastViewed(props.toast);
      authStore.toggleAccountModal(false);
      visible.value = false;
    };
  }
};

const markToastAsViewed = () => {
  $toastService.setToastViewed(props.toast);
  authStore.toggleAccountModal(false);
  visible.value = false;
};

watchEffect(async () => {
  if (!props.toast || !props.toast.contentPath) return;
  const { content } = await $contentService.fetchContent(
    props.toast.contentPath.replaceAll('%2F', '/'),
    'cms1.jpc.africa',
  );
  kenticoContent.value = content;
  if (!!kenticoContent.value) visible.value = true;
});

watch(
  () => kentico.value,
  (value) => {
    if (!!value) closeToast();
  },
);
</script>

<template>
  <LazyDesignSystemModal
    v-model:controller="visible"
    content-style="background: transparent !important; box-shadow: none; border: none;"
    type="toast"
  >
    <template #modal-content>
      <div
        v-if="kenticoContent"
        ref="kentico"
        @click="markToastAsViewed"
        v-html="kenticoContent"
      />
    </template>
  </LazyDesignSystemModal>
</template>
